import { registerApi as api } from '../../api';
import { globalApi as apiGlobal } from '../../api';

// export const downloadAllSelectedIDs = async(data)=>{
//     try {
//         const token=sessionStorage.getItem('token');
//         const response=await api.post(`/download_selected_records`,data,{
//             responseType: 'blob',
//             headers: {
//                 'Authorization': `Bearer ${token}`
//             }
//         });
//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'records.xlsx');
//         document.body.appendChild(link)
// ;
//         link.click();
//         link.remove();
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }

export const downloadAllSelectedIDs = async (data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/download_selected_records`, data, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 200 && response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${data.titleName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return { success: true };  // Return success flag to indicate download success
        } else {
            throw new Error("Invalid file response");
        }
    } catch (error) {
        console.log(error);
        throw error.response ? error.response.data.message : error.message;
    }
}
export const globalDownloadAllSelectedIDs = async (data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await apiGlobal.post(`/download_selected_records`, data, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 200 && response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${data.titleName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return { success: true };  // Return success flag to indicate download success
        } else {
            throw new Error("Invalid file response");
        }
    } catch (error) {
        console.log(error);
        throw error.response ? error.response.data.message : error.message;
    }
}
